module.exports = __webpack_public_path__ + "img/rights.900e5448.png";